// NPM
import { graphql, Link, useStaticQuery } from "gatsby"
import _ from "lodash"
import React, { useState } from "react"

// Components
import NavbarItem from "./NavbarItem"

const Header = ({ topNav, socialMedia, langs }) => {
  // State
  const [viewingNav, setViewingNav] = useState(false)

  const currentLanguage = langs.find(l => l.selected)

  const pageRoutes = _.sortBy(
    useStaticQuery(graphql`
      query {
        pages: allStrapiPage {
          nodes {
            uuid
            path
            locale
          }
        }
      }
    `).pages.nodes,
    o => o.path.length,
  ).reverse()

  const currentUrl = decodeURIComponent(currentLanguage.link)
  const currentLang = currentLanguage.langKey
  const pageRoutes$Lang = _.groupBy(pageRoutes, "locale")
  const pageRoutes$Lang$Uuid = _.mapValues(pageRoutes$Lang, group =>
    _.keyBy(group, "uuid"),
  )
  const maybeCurrentPageRoute = pageRoutes$Lang[currentLang].find(r => {
    return currentUrl.startsWith(r.path)
  })

  return (
    <header className="Header">
      <div className="container">
        <nav
          className="navbar is-transparent"
          role="navigation"
          aria-label="main navigation"
        >
          <div className="navbar-brand">
            <Link
              className="navbar-item"
              to={`/${currentLang === "en" ? "" : currentLang}`}
            >
              <img src={require("src/images/logos/vpl-logo.png").default} />
            </Link>

            <a
              onClick={() => setViewingNav(!viewingNav)}
              role="button"
              className={`navbar-burger ${viewingNav ? "is-active" : ""}`}
              aria-label="menu"
              aria-expanded="false"
            >
              <span aria-hidden="true"></span>
              <span aria-hidden="true"></span>
              <span aria-hidden="true"></span>
            </a>
          </div>

          <div
            id="TopNav"
            className={`navbar-menu ${viewingNav ? "is-active" : ""}`}
          >
            <div className="navbar-end">
              {_.get(topNav, "menus", []).map((navbarItem, navbarItemIndex) => {
                // Redirect to the current page in the requested lang if the URL
                // starts with `/lang/`.
                const maybeUrl = navbarItem?.link?.url
                if (maybeUrl?.startsWith("/lang/")) {
                  if (maybeCurrentPageRoute) {
                    const targetLang = maybeUrl.split("/")[2]
                    const targetRoute =
                      pageRoutes$Lang$Uuid[targetLang][
                        maybeCurrentPageRoute.uuid
                      ]
                    if (targetRoute?.path) {
                      navbarItem.link.url = targetRoute.path
                    } else {
                      if (targetLang == "en") {
                        navbarItem.link.url = "/"
                      } else {
                        navbarItem.link.url = "/" + targetLang
                      }
                    }
                  }
                }

                return (
                  <NavbarItem
                    key={`NavbarItem-${navbarItemIndex}`}
                    navbarItem={navbarItem}
                  />
                )
              })}
            </div>

            {/* <FooterBottomSocial socialMedia={socialMedia} /> */}
          </div>
        </nav>
      </div>
    </header>
  )
}

export default Header
